import { useState, useEffect } from 'react';
import GlossaryMarkdown from '~/widgets/GlossaryMarkdown/GlossaryMarkdown';
import { GLOSSARY_FILES } from '~/generated/glossary.files';
import styles from '~/pages/Rules/Rules.module.scss';

/**
 * Rules page that displays game documentation with inline definitions and hover tooltips.
 * Glossary blocks are rendered as React components, and terms show tooltips on hover/click.
 * Dynamically loads all rule markdown files from GLOSSARY_FILES.
 */
export default function Rules() {
  const [markdownContent, setMarkdownContent] = useState<string>('');

  useEffect(() => {
    const loadMarkdownFiles = async () => {
      const contents: string[] = [];

      for (const file of GLOSSARY_FILES) {
        try {
          const content = await file.import();
          contents.push(content);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn(`Failed to load markdown file: ${file.name}`, error);
        }
      }

      setMarkdownContent(contents.join('\n\n'));
    };

    loadMarkdownFiles();
  }, []);

  return (
    <div className={styles.rulesPage}>
      <div className={styles.content}>
        <GlossaryMarkdown recognitionMode="all" matchPlurality>
          {markdownContent}
        </GlossaryMarkdown>
      </div>
    </div>
  );
}
